import { render, staticRenderFns } from "./DepartmentUnitForm.vue?vue&type=template&id=65865022&"
import script from "./DepartmentUnitForm.vue?vue&type=script&lang=js&"
export * from "./DepartmentUnitForm.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentUnitForm.vue?vue&type=style&index=0&id=65865022&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports